import React from 'react'; 
import Background from '../../../components/patientApp/background/background'
import RecordComp from '../../../components/patientApp/record/record';

const Record = () => {
    return <Background>
        <RecordComp />
    </Background>
}
export default Record;